import { FlexBox } from '@dixa/lib-shared-habla';
import classNames from 'classnames';
import { PropsWithChildren } from 'lib-shared-types-utils';

import { AnalyticsSidenavSection as AnalyticsSidenavSectionT } from '../../analyticsSidenav.types';

import styles from './analyticsSidenavSection.module.scss';

type AnalyticsSidenavSectionProps = {
  /** The section object. */
  section: AnalyticsSidenavSectionT;
  /** Whether the section is visually hidden. */
  hidden: boolean;
} & PropsWithChildren;

export const AnalyticsSidenavSection = ({
  children,
  section,
  hidden = false,
}: AnalyticsSidenavSectionProps): JSX.Element => {
  const sectionClassName = classNames(styles.section, {
    [styles.sectionHidden]: hidden,
  });

  return (
    <FlexBox
      className={sectionClassName}
      flexDirection="column"
      role="menu"
      aria-hidden={hidden}
      aria-label={section.title}
    >
      {children}
    </FlexBox>
  );
};
